import styled from "styled-components";

export const WebFooter = styled.footer`
    background-color: ${(props) => props.theme.colors.primary.primary600};
    margin-top: auto;
`;

export const FooterSocialWrapper = styled.section`
    display: flex;
    flex-flow: column;

    @media (min-width: ${(props) => props.theme.layout.breakpoints.sm}) {
        flex-flow: row;
    }
`;

export const SocialItemsWrapper = styled.section`
    display: flex;
    justify-content: center;

    img {
        object-fit: scale-down;
        object-position: center;
        width: 100%;
        height: 100%;
    }
`;

export const SocialButtonsWrapper = styled.section`
    padding: ${(props) => props.theme.spacing.sm};
    background-color: ${(props) => props.theme.colors.primary.primary700};
    width: 100%;
`;

export const FooterSocialsTitle = styled.h2`
    color: ${(props) => props.theme.colors.neutral.white};
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.white};
    padding-bottom: ${(props) => props.theme.spacing.xs};
    width: 65%;
    margin: 0 auto ${(props) => props.theme.spacing.sm};
    font-size: ${(props) => props.theme.typography.body.normal.fontSize};
    line-height: normal;
    font-weight: 600;
`;

export const BannerImgLink = styled.a`
    display: flex;
    margin: 0 ${(props) => props.theme.spacing.xs};
    width: 129px;
    height: 38px;
`;

export const LegalContainer = styled.section`
    padding: ${(props) => props.theme.spacing.sm};
    margin: auto;
    text-align: center;
    color: ${(props) => props.theme.colors.neutral.white};
`;

export const LegalImgLink = styled.a`
    width: 100px;
    height: 35px;
    display: inline-block;
    margin-bottom: ${(props) => props.theme.spacing.sm};

    img {
        object-fit: scale-down;
        object-position: center;
        width: 100%;
        height: 100%;
    }
`;

export const Text = styled.p`
    font-size: ${(props) => props.theme.typography.body.medium.fontSize};
    line-height: ${(props) => props.theme.typography.body.medium.lineHeight};
    font-weight: ${(props) => props.theme.typography.body.medium.fontWeight};
    letter-spacing: 0.03rem;
`;

export const DefaultLink = styled.a`
    font-size: ${(props) => props.theme.typography.body.medium.fontSize};
    line-height: ${(props) => props.theme.typography.body.medium.lineHeight};
    font-weight: 900;
    color: ${(props) => props.theme.colors.neutral.white};
    text-decoration: none;

    &:hover {
        color: ${(props) => props.theme.colors.neutral.white};
        text-decoration: underline;
    }
`;

export const Pipe = styled.span`
    font-size: 13px;
`;

export const SocialsLink = styled.a`
    height: 32px;
    width: 32px;
    border-radius: 50%;
    display: flex;
    margin: 0 ${(props) => props.theme.spacing.xs};
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.colors.neutral.white};
    color: ${(props) => props.theme.colors.primary.primary700};
    fill: ${(props) => props.theme.colors.primary.primary700};

    &:last-of-type svg {
        width: 20px;
        height: 20px;
    }
`;
